import React from 'react';
import '../styles/BackgroundImage.css';

const BackgroundImage = () => {
    return (
        <>
            <div className="background-container"></div>
            <div className="background-container2"></div>
        </>
    );
};

export default BackgroundImage;
